/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationGroupModel
 */
export interface OrganizationGroupModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupModel
     */
    group_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationGroupModel
     */
    connect_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationGroupModel
     */
    ops_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationGroupModel
     */
    respond_user_auth_ids: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationGroupModel
     */
    allow_group_location_tracking: boolean;
    /**
     * 
     * @type {{ [key: string]: Array<any>; }}
     * @memberof OrganizationGroupModel
     */
    extra_fields?: { [key: string]: Array<any>; } | null;
}

/**
 * Check if a given object implements the OrganizationGroupModel interface.
 */
export function instanceOfOrganizationGroupModel(value: object): value is OrganizationGroupModel {
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('connect_user_auth_ids' in value) || value['connect_user_auth_ids'] === undefined) return false;
    if (!('ops_user_auth_ids' in value) || value['ops_user_auth_ids'] === undefined) return false;
    if (!('respond_user_auth_ids' in value) || value['respond_user_auth_ids'] === undefined) return false;
    if (!('allow_group_location_tracking' in value) || value['allow_group_location_tracking'] === undefined) return false;
    return true;
}

export function OrganizationGroupModelFromJSON(json: any): OrganizationGroupModel {
    return OrganizationGroupModelFromJSONTyped(json, false);
}

export function OrganizationGroupModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupModel {
    if (json == null) {
        return json;
    }
    return {
        
        'group_id': json['group_id'],
        'connect_user_auth_ids': json['connect_user_auth_ids'],
        'ops_user_auth_ids': json['ops_user_auth_ids'],
        'respond_user_auth_ids': json['respond_user_auth_ids'],
        'allow_group_location_tracking': json['allow_group_location_tracking'],
        'extra_fields': json['extraFields'] == null ? undefined : json['extraFields'],
    };
}

export function OrganizationGroupModelToJSON(json: any): OrganizationGroupModel {
    return OrganizationGroupModelToJSONTyped(json, false);
}

export function OrganizationGroupModelToJSONTyped(value?: OrganizationGroupModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['group_id'],
        'connect_user_auth_ids': value['connect_user_auth_ids'],
        'ops_user_auth_ids': value['ops_user_auth_ids'],
        'respond_user_auth_ids': value['respond_user_auth_ids'],
        'allow_group_location_tracking': value['allow_group_location_tracking'],
        'extraFields': value['extra_fields'],
    };
}

